<template>
    <div class="view">

        <Head @ck="menuOpen=true">{{ $t("menu.myNote")}}</Head>
        <div class="cont">
            <div class="gup" v-for="(item, key) in nodeGurup" :key="key">
                <div class="til">{{key}}</div>
                <div class="list">
                    <div class="item bn" v-for="word in item" :key="word.Id" @click="selWord(word)">{{word.Text}}
                        <span class="del" @click.stop="delNode(word)"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import mainDelegate from '@/delegate/mainDelegate'
import myNoteDelegate from '@/delegate/myNoteDelegate'
export default {
    name: 'MyNote',
    mixins: [mainDelegate, myNoteDelegate],
    methods: {
        delNode(word) {
            this.removeVocabularyToNoteAndReload(word.Id)
        },
        selWord(word) {
            this.word = word
        }
    }
}
</script>

<style lang="less" scoped>
@import 'val.less';
@import 'view.less';
@border-color: #bbb;
.cont {
    text-align: left;
    .gup {
        background: #fafafa;
        border: solid 1px @border-color;
        border-radius: 5px;
        margin: 16px;
        .til {
            font-size: 14px;
            color: @main-color;
            line-height: 20px;
            margin: 16px 16px 0px 16px;
        }
        .list {
            .item {
                padding: 9px 16px 10px 16px;
                line-height: 28px;
                font-size: 20px;
                color: @greyishBrown;
                border-bottom: solid 1px @border-color;

                .del {
                    float: right;
                    width: 28px;
                    height: 28px;
                    background: url(../assets/img/delete.png);
                    background-repeat: no-repeat;
                    background-position: right;
                    cursor: pointer;
                    &:active {
                        filter: brightness(80%);
                    }
                    &:hover {
                        filter: brightness(80%);
                    }
                }
            }
        }
    }
}
@media only screen and (min-width: @rwd) {
    .cont {
        max-width: 480px;
        margin: 0px auto;
        .gup {
            .list {
                .item {
                    &:hover {
                        background: @white;
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/page/MyNote.vue